import { css } from '@emotion/react';
import { ThemeType } from 'types';

export const stylesInit = (theme: ThemeType) => ({
  DelegateStatusText: css`
    font-weight: 600;
    font-size: 16px;
  `
});
